import { rem } from "@certn/cascadia";
import { Card, Illustration, Text } from "@certn/cascadia-react";
import { CascadiaIllustration } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";

import { AppTitle } from "../AppTitle";

export interface EmptyStateProps {
  illustration: CascadiaIllustration;
  size?: number;
  title?: React.ReactNode;
  description: React.ReactNode;
  hideBorder?: boolean;
}

export function EmptyState(props: EmptyStateProps) {
  const { illustration, size = 88 } = props;

  return (
    <Card
      type="large"
      border={props.hideBorder ? "none" : "border-base"}
      background="background-base"
      className={css(styles.card, size > 88 && { gap: rem("space-6") })}
    >
      <Illustration name={illustration} size={size} />
      <div className={styles.titles}>
        {props.title && <AppTitle title={props.title} textAlign="center" />}
        <Text style="global/body-secondary" color="text-weak" align="center">
          {props.description}
        </Text>
      </div>
    </Card>
  );
}

const styles = {
  card: css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: rem("space-6"),
    gap: rem("space-4"),
  }),
  titles: css({
    display: "flex",
    flexDirection: "column",
    gap: rem("space-1"),
  }),
};
